import React from 'react';
import { AlertOctagon } from 'lucide-react';
import type { AdvanceDirectiveSummary } from './usePatientChartSummary';

const formatDate = (value: string | null): string => {
  if (!value) return '';
  const [y, m, d] = value.slice(0, 10).split('-');
  return y && m && d ? `${m}/${d}/${y}` : value;
};

/**
 * Chart header banner (Phase 19 F19): an out-of-hospital DNR is on file. Shown on every tab so
 * staff see it before acting in an emergency. Renders nothing for any other status.
 */
const OohDnrBanner: React.FC<{ advanceDirective: AdvanceDirectiveSummary | null; compact?: boolean }> = ({ advanceDirective, compact = false }) => {
  if (advanceDirective?.status !== 'OOH_DNR') return null;
  return (
    <div
      role="note"
      aria-label="Out-of-hospital DNR"
      data-testid="ooh-dnr-banner"
      className={`flex items-center gap-2 border-y border-red-300 bg-red-50 font-semibold text-red-800 ${compact ? 'px-2 py-1 text-xs' : 'px-5 py-1.5 text-sm'}`}
    >
      <AlertOctagon size={compact ? 14 : 16} className="flex-shrink-0" aria-hidden="true" />
      <span>
        Out-of-hospital DNR on file
        {advanceDirective.formDate && <span className="font-normal"> · Form dated {formatDate(advanceDirective.formDate)}</span>}
      </span>
    </div>
  );
};

export default OohDnrBanner;
